<template>
  <div :class="['pipe-settings', isEditing]">
    <div class="pipe-settings__header pipe-row">
      <p>{{ pipingStatusLabel }}</p>
      <div>
        <button @click="togglePipeEdit">{{ pipeEditLabel }}</button>
      </div>
    </div>
    <div class="pipe-settings__edit">
      <div class="pipe-edit-row">
        <p>Pipe to Are.na</p>
        <button v-if="canTurnOnArena" @click="turnOnArena()">Turn On</button>
        <button v-if="!canTurnOnArena" @click="turnOffArena()">Turn Off</button>
      </div>
      <div>
        <div class="pipe-row">
          <p>Idea Channel: <input v-model="newIdeaChannel" placeholder="New channel url" /></p>
          <p v-if="hasIdeaChannel">⇒ <a :href="$store.state.org.piping.arena.ideaChannel" target="_blank" rel="noopener">{{ $store.state.org.piping.arena.ideaChannel.split('/')[4] }}</a></p>
          <p v-if="!hasIdeaChannel">No channel yet.</p>
        </div>
        <div class="pipe-row">
          <p>Reference Channel: <input v-model="newReferenceChannel" placeholder="New channel url" /></p>
          <p v-if="hasReferenceChannel">⇒ <a :href="$store.state.org.piping.arena.referenceChannel" target="_blank" rel="noopener">{{ $store.state.org.piping.arena.referenceChannel.split('/')[4] }}</a></p>
          <p v-if="!hasReferenceChannel">No channel yet.</p>
        </div>
        <button @click="updateArenaPipeChannels()">Update Channels</button>
      </div>
      <p class="error" v-if="$store.state.org.arenaPipeErrorMessage">{{ $store.state.org.arenaPipeErrorMessage }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PipeSettings',
  components: {
  },
  props: [],
  data() {
      return {
        editingPipes: false,
        newIdeaChannel: null,
        newReferenceChannel: null,
      }
  },
  computed: {
    isEditing(){
      return this.editingPipes ? 'is--editing' : '';
    },
    pipeEditLabel(){
      return this.editingPipes ? 'Close' : 'Edit';
    },
    hasArenaSettings(){
      if(this.$store.state.org.piping != null){
        if(this.$store.state.org.piping.arena != undefined){
          return true;
        }
      }
      return false;
    },
    pipingStatusLabel(){
      if(this.hasArenaSettings){
        if(this.$store.state.org.piping.arena.on){
          return 'ON for Are.na';
        }
      }

      return 'OFF for Are.na';
    },
    canTurnOnArena(){
      if(this.hasArenaSettings){
        return !this.$store.state.org.piping.arena.on;
      } else {
        return true;
      }
    },
    hasIdeaChannel(){
      if(this.hasArenaSettings){
        if(this.$store.state.org.piping.arena.ideaChannel != undefined){
          return true
        }
      }
      return false;
    },
    hasReferenceChannel(){
      if(this.hasArenaSettings){
        if(this.$store.state.org.piping.arena.referenceChannel != undefined){
          return true
        }
      }
      return false;
    }
  },
  mounted() {

  },
  methods: {
    togglePipeEdit(){
      this.editingPipes = !this.editingPipes;
    },
    turnOnArena(){
      this.$store.dispatch('updateArenaPipe', { on: true });
    },
    turnOffArena(){
      this.$store.dispatch('updateArenaPipe', { on: false });
    },
    updateArenaPipeChannels(){
      let newIdeaChannel = this.newIdeaChannel || null;
      let newReferenceChannel = this.newReferenceChannel || null;
      this.$store.dispatch('updateArenaPipeChannels', { newIdeaChannel, newReferenceChannel });
    },
  },
  watch: {
    '$store.state.org.piping.arena.ideaChannel' () {
      this.newIdeaChannel = null;
    },
    '$store.state.org.piping.arena.referenceChannel' () {
      this.newReferenceChannel = null;
    },
  }
}

</script>

<style>

.pipe-settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  padding-right: 0;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-bottom: 1px solid var(--beige-500);
  transition: all 200ms ease-in-out;
}


.pipe-settings__header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  width: 100%;
}

.pipe-settings__edit {
  width: 100%;
  height: 0;
  overflow: hidden;
  pointer-events: none;
  width: 100%;
  transition: all 200ms ease-in-out;
}

.pipe-settings__edit-contents {
  padding: 20px;
  padding-right: 0;
  width: 100%;
  box-sizing: border-box;
  transition: all 200ms ease-in-out;
}

.pipe-settings.is--editing {
  border-left: 1px solid var(--beige-500);
  border-right: 1px solid var(--beige-500);
  border-top: 1px solid var(--beige-500);
  background: var(--beige-200);
}

.pipe-settings.is--editing .pipe-settings__header {

}

.pipe-settings.is--editing .pipe-settings__edit {
  height: fit-content;
  pointer-events: all;
}

.pipe-edit-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  padding-right: 20px;
  border-bottom: 1px solid var(--beige-600);
}

.pipe-edit-row:last-child {
  border-bottom: none;
}

.pipe-edit-row.align-top {
  align-items: flex-start;
}

.pipe-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 20px;
  box-sizing: border-box;
}

</style>
